import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetOfficeEquipmentBrandsInput, OfficeEquipmentBrandInput, OfficeEquipmentBrandResult, Result, ResultList, SingleResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class OfficeEquipmentBrandService {

  constructor(private httpClient: HttpClient) { }

  public addOfficeEquipmentBrand(officeEquipmentBrandInput: OfficeEquipmentBrandInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentBrand/AddOfficeEquipmentBrand', officeEquipmentBrandInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editOfficeEquipmentBrand(id: number, officeEquipmentBrandInput: OfficeEquipmentBrandInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'OfficeEquipmentBrand/EditOfficeEquipmentBrand?id=' + id, officeEquipmentBrandInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteOfficeEquipmentBrand(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'OfficeEquipmentBrand/DeleteOfficeEquipmentBrand?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getOfficeEquipmentBrand(id: number): Promise<SingleResult<OfficeEquipmentBrandResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'OfficeEquipmentBrand/GetOfficeEquipmentBrand?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<OfficeEquipmentBrandResult>(OfficeEquipmentBrandResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<OfficeEquipmentBrandResult>(OfficeEquipmentBrandResult), result.error));
  }

  public getOfficeEquipmentBrands(getOfficeEquipmentBrandsInput: GetOfficeEquipmentBrandsInput): Promise<ResultList<OfficeEquipmentBrandResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentBrand/GetOfficeEquipmentBrands', getOfficeEquipmentBrandsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OfficeEquipmentBrandResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OfficeEquipmentBrandResult>(), result.error));
  }
}
